import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';
import VueI18n from 'vue-i18n';
import config from '@/config/vuetify';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function BootstrapVuetify(i18n: VueI18n): Vuetify {
  Vue.use(Vuetify);
  return new Vuetify(config);
}
